module.exports = {
  400: 'Vul alstublieft alle vereiste velden in.',
  404: 'De gevraagde actie is niet gevonden.',
  401: 'U bent niet geautoriseerd voor deze actie.',
  acceptTerms: 'U dient onze algemene voorwaarden te accepteren',
  emailNotFound: 'Uw e-mailadres kan niet gevonden worden.',
  fillAllFields: 'Vul alstublieft alle vereiste velden in.',
  general: 'Er ging iets fout. Probeer het later opnieuw.',
  invalidCredentials: 'Uw e-mailadres en wachtwoord komen niet overeen met onze gegevens',
  invalidPassword: 'Uw huidige wachtwoord komt niet overeen met onze gegevens.',
  maintenance: {
    description: 'Deze service is momenteel niet beschikbaar. Probeer het later opnieuw.',
    title: 'Onderhoud',
  },
  page: {
    description: 'Oeps! Er ging is iets misgegaan. We konden de gevraagde pagina niet vinden.',
    title: 'Pagina niet gevonden',
  },
  validation: {
    email: 'Dit is geen geldige e-mail.',
    min: {
      string: 'Dit moet minimaal 6 tekens lang zijn.',
    },
    required: 'Dit veld is verplicht.',
  },
  systemDefinition: {
    lessControllersThanCircuits: 'Er zijn momenteel minder controllers dan kringen',
  },
};



// WEBPACK FOOTER //
// ./js/lang/nl/errors.js